import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from '../../app.state';
import { AppSettings } from '../../shared/Constants/sharedConstants';
import { selectUserInformation } from '../../state/selectors/user-profile.selectors';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'left-nav-secondary-links',
  templateUrl: './left-nav-secondary-links.component.html',
  styleUrls: ['./left-nav-secondary-links.component.css']
})
export class LeftNavSecondaryLinksComponent implements OnInit {

  links: any = [];
  sub: Subscription = null;
  canAccessLegacy = true;

  constructor(private store: Store<AppState>,
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {

    this.sub = this.store.select(selectUserInformation).subscribe(userInfo => {
      this.canAccessLegacy = userInfo?.automaticRedirect === true ? false : true;

      this.links = [
        {
          text: this.translate.instant("PageMenu.SwitchToLegacyView"),
          url: AppSettings.UIAppConfig?.leftNavLinks.legacyAppLoginUrl
        },
        {
          text: this.translate.instant("PageMenu.DownloadResources"),
          url: AppSettings.UIAppConfig?.leftNavLinks.downloadResourcesUrl
        },
        {
          text: this.translate.instant("PageMenu.SelfInstallGuid"),
          url: AppSettings.UIAppConfig?.leftNavLinks.selfInstallGuideUrl
        },
        {
          text: this.translate.instant("PageMenu.CustomerService"),
          url: AppSettings.UIAppConfig?.leftNavLinks.customerServiceUrl
        },
      ];
    }
    );
  }
}
